import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDJYGtbE-_Pn3VBpSHBGMDYQtPGDKWJiBU",
  authDomain: "calvin-id.firebaseapp.com",
  projectId: "calvin-id",
  storageBucket: "calvin-id.firebasestorage.app",
  messagingSenderId: "264199225885",
  appId: "1:264199225885:web:f9a53fd02f22a8d8373cf4",
  measurementId: "G-37RF2FS65L"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);

// Connect to local emulators (only in development)
// Comment out the lines below if you want to use the real Firebase project instead
if (import.meta.env.DEV) {
  // Uncomment these lines to use emulators:
  // connectFirestoreEmulator(db, "127.0.0.1", 8080);
  // connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
}


export const analytics = getAnalytics(app);

// Export the app instance as default
export default app;
